import { useState as u, useEffect as c } from "react";
const i = (s) => {
  const [o, t] = u(!1);
  return c(() => {
    const e = s.current;
    if (!e) return;
    const r = () => {
      t(!0);
    }, n = () => {
      t(!1);
    };
    return t(document.activeElement === e), e.addEventListener("focus", r), e.addEventListener("blur", n), () => {
      e.removeEventListener("focus", r), e.removeEventListener("blur", n);
    };
  }, [s]), {
    isFocused: o
  };
};
export {
  i as u
};
